<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="huodao">
			<div class="item-1" v-for="(item,i) in macAisle" :key="i">
				<div class="item-2" v-for="(aisle,j) in item.b" :key="j">
					 <Tag closable  v-if="item.b.length-1==j" color="success"   @on-close="deleteAisle(aisle,i)">{{aisle.number}}</Tag>
					 <Tag  v-else   color="success"  @on-close="deleteAisle(aisle,i)">{{aisle.number}}</Tag>
				</div>
				<div>
					<Button type="info" @click="addAiske(item.b[0].number1)" v-show="item.b.length>0">新增</Button>
				</div>
			</div>
			
			<Button type="info" @click="addAiske1()" >新增</Button>
		</div>
	</div>
</template>

<script>
	import http from '../../../../http/http.js'
	export default {
		data() {
			return {
				loading:false,
				macDetails:{},
				t:true,
				row: '', //行数
				columns: '', //列数
				maxNumber: 6, //最大商品数
				remark: '', //备注
				total: 0,
				macAisle: [],
				macId:'',
				aisle1: {
					number: '',
					number1: '',
					number2: '',
					remark: '',
					maxNumber: 6,
					sortNumber:''
				},
				manualAddState:0

			}
		},
		methods: {
			addAiske1(){
				let _this=this
				
				let m=this.macAisle[this.macAisle.length-1].b[this.macAisle[this.macAisle.length-1].b.length-1]
				let number=parseInt(m.number1)+1
				console.log(number)
				
				let a={
					        id:0,
							sortNumber:m.sortNumber+1,
							number: number + '-' + 1,
							number1: number ,
							number2: 1 ,
							remark: this.remark,
							maxNumber: this.maxNumber
				}
				let c=[]
				c.push(a)
				let d={
					b:c
				}
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'POST',
					url: http.url + '/mac/leave/factory/aisle/addAilse',
					data: {
						macId:_this.macId,
						number1:a.number1,
						number2:a.number2
					},
					_this: _this,
					success: function(data) {
						a.id=data.id
				        _this.macAisle.push(d)
					}
				})
				
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			addAiske(i){
				let _this=this
				let m=this.macAisle[i-1].b[this.macAisle[i-1].b.length-1]
				let number=parseInt(m.number2)+1
				console.log(m)
				let a={
					        id:0,
							sortNumber:m.sortNumber+1,
							number: i + '-' + number,
							number1: i ,
							number2: number ,
							remark: this.remark,
							maxNumber: this.maxNumber
				}
				
				
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/addAilse',
					data: {
						macId:_this.macId,
						number1:a.number1,
						number2:a.number2
					},
					_this: _this,
					success: function(data) {
						a.id=data.id
						_this.macAisle[i-1].b.push(a)
					}
				})
				
			},
			deleteAisle(aisle,i) { //删除货道信息
			    let _this=this
				let aaa=_this.macAisle[i].b[_this.macAisle[i].b.length-1]
				if(aaa.number2==1 && _this.macAisle.length!=i+1){
					this.$Message.error('不允许删除中间行');
					return ;
				}
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/deleteAilse',
					data: {
						macId:_this.macId,
						aisleId:aaa.id
					},
					_this: _this,
					success: function(data) {
						console.log(aaa)
						if(Number(aaa.number2)!=1){
							_this.macAisle[i].b.splice(_this.macAisle[i].b.length-1,1)
						}else{
							_this.macAisle.splice(i,1)
						}
						
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
				
			},
		
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/st',
					data: {
						id:_this.macId,
						page:0,
						size:100
					},
					_this: _this,
					success: function(data) {
						_this.macAisle = data.list
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			},
		},
		created() {
			let _this=this
			_this.macId=_this.$route.query.id
			_this.ajaxPage()
		}
	}
</script>

<style scoped="scoped" lang="less">
	.ivu-tag{
		width: 70px;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		max-width: 1200px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}

	.ivu-row {
		/* margin-bottom: 20px; */
	}
	.huodao{
		 .item-1{
		 	
		 		display: flex;
				align-items: center;
				flex-wrap: wrap;
				.item-2{
					display: flex;
					align-items: center;
				   height: 40px;
				}
		 }
		
	}
	
</style>



// WEBPACK FOOTER //
// src/components/alliance/mac/aisle/update.vue